import { useState } from "react";
import AgentResponseLayout from "../../../components/agent/AgentResponseLayout";
import SelectInput from "../../../components/forms/SelectInput";
import MultiSelectInput from "../../../components/forms/MultiSelectInput";
import NotesField from "../../../components/forms/NotesField";
import { useAgentResponse } from "../../../js/hooks/useAgentResponse";
import {
  COOLING_OPTIONS,
  ELECTRICAL_OPTIONS,
  ENERGY_OPTIONS,
  HEATING_OPTIONS,
  HVAC_OPTIONS,
  INTERNET_OPTIONS,
  PLUMBING_OPTIONS,
  SEWER_OPTIONS,
  SMART_HOME_OPTIONS,
  WATER_HEATER_OPTIONS,
} from "../../../js/utils/agentResponseOptions";

export default function AgentResponseSystems() {
  const { response, saveSection, goBack, goNext } = useAgentResponse("systems");
  const saved = response?.systems || {};
  const [form, setForm] = useState(null);
  const current = form || saved;

  function update(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...(prev || saved), [name]: value }));
  }

  async function handleContinue() {
    await saveSection(current);
    goNext();
  }

  if (!response) {
    return (
      <AgentResponseLayout title="Systems" onBack={goBack} onContinue={() => {}}>
        <p>Loading response…</p>
      </AgentResponseLayout>
    );
  }

  return (
    <AgentResponseLayout
      response={response}
      sectionKey="systems"
      title="Systems"
      lead="HVAC, electrical, plumbing, water, sewer, connectivity, and efficiency — the details that rarely show well in photos."
      onBack={goBack}
      onContinue={handleContinue}
    >
      <section className="checklist-section">
        <h2>Climate & Mechanicals</h2>
        <MultiSelectInput label="HVAC type" name="hvac" values={current.hvac || []} onChange={update} options={HVAC_OPTIONS} />
        <SelectInput label="Heating fuel" name="heating" value={current.heating} onChange={update} options={HEATING_OPTIONS} />
        <SelectInput label="Cooling" name="cooling" value={current.cooling} onChange={update} options={COOLING_OPTIONS} />
        <SelectInput label="Water heater" name="waterHeater" value={current.waterHeater} onChange={update} options={WATER_HEATER_OPTIONS} />
      </section>
      <section className="checklist-section">
        <h2>Electrical, Plumbing & Utilities</h2>
        <SelectInput label="Electrical" name="electrical" value={current.electrical} onChange={update} options={ELECTRICAL_OPTIONS} />
        <SelectInput label="Plumbing" name="plumbing" value={current.plumbing} onChange={update} options={PLUMBING_OPTIONS} />
        <SelectInput label="Sewer / septic" name="sewer" value={current.sewer} onChange={update} options={SEWER_OPTIONS} />
        <SelectInput label="Internet" name="internet" value={current.internet} onChange={update} options={INTERNET_OPTIONS} />
      </section>
      <section className="checklist-section">
        <h2>Smart Home & Energy</h2>
        <MultiSelectInput label="Smart home" name="smartHome" values={current.smartHome || []} onChange={update} options={SMART_HOME_OPTIONS} />
        <MultiSelectInput label="Energy features" name="energy" values={current.energy || []} onChange={update} options={ENERGY_OPTIONS} />
        <NotesField
          label="Systems notes"
          name="notes"
          value={current.notes}
          onChange={update}
          placeholder="Ages if known, dual-zone comfort, well water, or anything to verify before an offer."
        />
      </section>
    </AgentResponseLayout>
  );
}
